import {SubAPI} from "./SubAPI";
import {DateString} from "./Projects";

export class DDLOptions extends SubAPI {
    list(props: {
        category?: DDLCategory;
        project?: number;
    }) {
        return this.fetcher.get<DDLValue[]>("/api/opening/defaults", props)
    }

    upsert(input: DDLValue) {
        return this.fetcher.post<DDLValue>("/api/opening/default", input);
    }

    reSort(input: {
        ids: number[];
    }) {
        return this.fetcher.post<DDLValue>("/api/opening/default/re-sort", input);
    }

    upsertDefaultLiteKitProfile(input: {
        name: string;
        file?: number | null;
    }) {
        return this.fetcher.post<DDLValue>("/api/opening/default/lite-kit-profile", input);
    }
}

export type DDLCategory =
    'frameProfile' |
    'doorLiteKit' |
    'doorElevation' |
    'drwDoorElevation' |
    'doorCore' |
    'doorSeam' |
    'doorMaterial' |
    'doorMaterialWoodSpecies' |
    'doorMaterialWoodCut' |
    'doorMaterialWoodMatching' |
    'doorMaterialWoodFinish' |
    'doorMaterialWoodMatchingMethod' |
    'doorMaterialWoodPly' |
    'screenElevation';

export type DDLValue = {
    id: number;

    category: DDLCategory;

    value: string;
    label: string;
    printLabel: string | null;
    attachment: number | null;
    attachmentName: string | null;
    // the drawing of a drwDoorElevation row. null until drawn.
    drwDoorElevation?: number | null;

    frameSeries: string | null;
    doorSeries: string | null;
    canHaveThermal: boolean | null;

    archived: boolean;

    createdAt: DateString;
    updatedAt: DateString;
    sortOrder: number;
}